import Masonry from 'masonry-layout';
import './libs/jquery.formstyler.min.js';

const grid        = document.querySelector('.news-page');
const $filters    = $(grid).find('.view-filters');
const $select     = $filters.find('select');
const $input      = $filters.find('input[type="text"]');
const gutter      = 5;

export function selectStyler() {
  $select.styler();
  setTimeout(function() {
    $input.styler();
  }, 1000);
}

export function makeSquareBlocks(page, elms, msnry) {
  [ ...elms ].map((el) => {
    const elWidth  = $(el).outerWidth();

    if ($(el).hasClass('size1x2')) {
      $(el).css('height', elWidth/2-gutter/2)
    } else if ($(el).hasClass('size2х3')) {
      $(el).css('height', elWidth/3*2-2)
    } else {
      $(el).css('height', elWidth)
    }
    msnry.layout();
    $(el).css('transition', 'none');
  });
  page.addClass('loaded');
}

export function msnryGrid(page, grid, selector, column, stp) {
  const blocks = page.find(selector);
  const stapm = !stp ? false : stp;
  const msnry = new Masonry(grid, {
    itemSelector: selector,
    percentPosition: true,
    columnWidth: column,
    gutter: gutter,
    stagger: 30,
    stamp: stapm
  });
  makeSquareBlocks(page, blocks, msnry);

  $(window).on('resize', function () {
    makeSquareBlocks(page, blocks, msnry);
  })
}



// WEBPACK FOOTER //
// ./js/news.js